import { render, staticRenderFns } from "./StudentCard.vue?vue&type=template&id=d08867a2&scoped=true&"
import script from "./StudentCard.vue?vue&type=script&lang=js&"
export * from "./StudentCard.vue?vue&type=script&lang=js&"
import style0 from "./StudentCard.vue?vue&type=style&index=0&id=d08867a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08867a2",
  null
  
)

export default component.exports